/** Google Maps JavaScript API version the finder map requests. */
export const FINDER_MAPS_API_VERSION = "3.49";
